// eslint-disable-next-line import/prefer-default-export
export const ShiftlineSelectionModals = Object.freeze({
    None: 0,
    AutoNumbering: 1,
    Close: 2,
    ConfirmBidSelection: 3,
    DeclineBid: 4,
    SaveTemplate: 5,
    LoadTemplate: 6,
    Back: 7,
    BackOnBehalf: 8,
});
